export default {
  ADDRESS: 'ADDRESS',
  DELIVERY: 'DELIVERY',
  PAYMENT: 'PAYMENT',
  CONTACT: 'CONTACT',
  COLLECTION: 'COLLECTION',
};
